import { useEffect, useState } from "react";
import { AccessibilityInfo } from "react-native";

// THE shared reduce-motion probe (AP-0d — first animation that needed a
// static fallback; greenfield, so this is the single primitive every future
// animated surface reads instead of a bespoke AccessibilityInfo gate).
// Reads the OS setting once and follows changes. On web (react-native-web)
// AccessibilityInfo resolves from prefers-reduced-motion where supported and
// falls back to false — animating is the safe default when unknown.
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    let cancelled = false;
    AccessibilityInfo.isReduceMotionEnabled()
      .then((v) => {
        if (!cancelled) setReduced(!!v);
      })
      .catch(() => {});
    const sub = AccessibilityInfo.addEventListener(
      "reduceMotionChanged",
      (v) => setReduced(!!v),
    );
    return () => {
      cancelled = true;
      sub?.remove?.();
    };
  }, []);
  return reduced;
}
